'use strict';
import controller from './tableGridRow.controller';

let tableGridRowComponent = ($compile) => {
  return {
    replace: false,
    scope: {
      row: '=',
      columns: '=',
      options: '=',
      metaData: '=',
      fetchResults: '&',
      rowsSelected: '='
    },
    controller,
    controllerAs: 'vm',
    link: {
      pre: (scope, el, attrs, ctrl) => {
        scope.vm = scope;
        scope.vm.fetchMoreData = ctrl.fetchMoreData;
        scope.vm.isActive = ctrl.isActive;

        let templateString = '';
        scope.columns.forEach((column) => {
          let tdClass = column.truncated ? 'class="tableGrid__truncated"' : '';
          let leftTemplate = `<td ${tdClass}`;
          let rightTemplate = '';
          
          if(column.type === 'table-grid-checkbox-cell'){
            rightTemplate = `><${column.type} row='vm.row' rows-selected="vm.rowsSelected"  meta-data ='vm.metaData' options ='vm.options' columns='vm.columns' column-name='${column.name}'></${column.type}></td>`;
          }else{
            rightTemplate = `><${column.type} row='vm.row' meta-data ='vm.metaData' options ='vm.options' columns='vm.columns' column-name='${column.name}'></${column.type}></td>`;
          }
         
          if (column.type) {
            templateString += `${leftTemplate}`;
            templateString = getTemplateStringIfClickable(column, templateString);
            templateString = getTemplateStringIfToolTip(scope.row, column, templateString);
            templateString += `${rightTemplate}`;
          }
        });

        let rowElements = $compile(angular.element(templateString))(scope);
        el.append(rowElements);
      }
    }
  };
};

function getTemplateStringIfClickable(column, templateString) {
  if (column.isClickable) {
    templateString += 'ng-class={\'table-data__isActive\':vm.isActive(row)} ng-click=vm.fetchMoreData(row)';
  }
  return templateString;
}

function getTemplateStringIfToolTip(row, column, templateString) {
  if (column.tooltip && column.tooltip(row)) {
    let tooltipText = column.tooltip(row);
    templateString += `uib-tooltip="${tooltipText}"`;
  }
  return templateString;
}


tableGridRowComponent.$inject = ['$compile'];

export
default tableGridRowComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridRow/tableGridRow.component.js